const collectionTabs = () => {
    const classes = {
        buttonActive: 'tabs-nav__button--active',
    };
    const selectors = {
        collectionTabs: '[data-collection-tabs]',
        tabs: '[data-mobile-tab-controls]',
        mobileTab: '[data-mobile-tab]',
        mobileTabIndex: 'data-mobile-tab',
        mainTab: '[data-tab]',
        mainTabIndex: 'data-tab',
    };
    const collectionsTabsSections = document.querySelectorAll(selectors.collectionTabs);
    if (collectionsTabsSections) {
        collectionsTabsSections.forEach((section) => {
            const mainTabs = section.querySelectorAll(selectors.mainTab);
            const mobileTabs = section.querySelectorAll(selectors.mobileTab);
            const mobileTabContainer = section.querySelector(selectors.tabs);
            if (mainTabs) {
                mainTabs.forEach((tab) => {
                    const tabIndex = tab.getAttribute(selectors.mainTabIndex);
                    tab.addEventListener('click', () => {
                        mobileTabs.forEach((tab) => {
                            tab.classList.remove(classes.buttonActive);
                        });
                        const matchingMobileTab = section.querySelector('[' + selectors.mobileTabIndex + '="' + tabIndex + '"]');
                        matchingMobileTab.classList.add(classes.buttonActive);
                    });
                });
            }
            if (mobileTabContainer) {
                const mobileTabs = mobileTabContainer.querySelectorAll(selectors.mobileTab);
                mobileTabs.forEach((tab) => {
                    const tabIndex = tab.getAttribute(selectors.mobileTabIndex);
                    const mainTab = section.querySelector('[' + selectors.mainTabIndex + '="' + tabIndex + '"]');
                    tab.addEventListener('click', () => {
                        const offsetLeft = tab.offsetLeft;
                        const tabWidth = tab.offsetWidth;
                        const containerWidth = mobileTabContainer.offsetWidth;
                        let extraSpace = containerWidth - tabWidth;
                        extraSpace = extraSpace / 2;
                        mobileTabContainer.scrollLeft = offsetLeft - extraSpace;
                        mobileTabs.forEach((tab) => {
                            tab.classList.remove(classes.buttonActive);
                        });
                        tab.classList.add(classes.buttonActive);
                        if (mainTab) {
                            mainTab.click();
                        }
                    });
                });
            }
        });
    }
};
export { collectionTabs };
